import { useStore } from '@store/index';
import { buildOrgRoutePath, buildRoutePath, removeOrgPrefix } from '@utils/routes';
import React from 'react';
import { Navigate, Outlet, useParams } from 'react-router-dom';

import { useShouldShowQcPage } from '@/hooks/useShouldShowQcPage';

/**
 * Validates that the QC page should be accessible based on the user's current
 * scoped roles. Waits for the role query to complete before deciding.
 */
export function QcRouteValidator() {
  const { selectedOrganizationId, selectedProgramId } = useStore();
  const { orgId } = useParams<{ orgId?: string }>();
  const routeOrganizationId = orgId ? removeOrgPrefix(orgId) : null;
  const effectiveOrganizationId = routeOrganizationId || selectedOrganizationId;
  const { shouldShow, isLoading } = useShouldShowQcPage({
    organizationId: effectiveOrganizationId,
    programId: null,
  });

  if (isLoading) {
    return null;
  }

  if (!shouldShow || !effectiveOrganizationId) {
    if (effectiveOrganizationId && selectedProgramId) {
      return (
        <Navigate
          to={buildRoutePath('/cases', effectiveOrganizationId, selectedProgramId)}
          replace
        />
      );
    }

    if (effectiveOrganizationId) {
      return <Navigate to={buildOrgRoutePath('', effectiveOrganizationId)} replace />;
    }

    return <Navigate to="/" replace />;
  }

  return <Outlet />;
}
